module.exports = __webpack_public_path__ + "static/media/default_avatar.e147bdeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/default_avatar.png
// module id = 3368
// module chunks = 0